export default __webpack_public_path__ + "static/media/TIEMPO_REAL_ICON.79dce53f.svg";